import { ROUTES } from "routes";
import { Role } from "types/user";

const PROVIDER_ONLY_PREFIXES = [ROUTES.MY_SERVICES, ROUTES.FAVORITES] as const;

const CLIENT_ONLY_PREFIXES = [ROUTES.MY_ADS, `${ROUTES.ACCOUNT}/mes-prestataires`] as const;

function normalizePath(pathname: string): string {
    const path = pathname.split("?")[0].split("#")[0];
    if (path.length > 1 && path.endsWith("/")) {
        return path.slice(0, -1);
    }
    return path;
}

function matchesPrefix(pathname: string, prefix: string): boolean {
    const path = normalizePath(pathname);
    const base = normalizePath(prefix);
    return path === base || path.startsWith(`${base}/`);
}

export function canAccessPathWithRole(pathname: string, role: string): boolean {
    for (const prefix of PROVIDER_ONLY_PREFIXES) {
        if (matchesPrefix(pathname, prefix)) {
            return role === Role.PROVIDER;
        }
    }

    for (const prefix of CLIENT_ONLY_PREFIXES) {
        if (matchesPrefix(pathname, prefix)) {
            return role === Role.CLIENT;
        }
    }

    if (matchesPrefix(pathname, `${ROUTES.ACCOUNT}/collaborateurs`)) {
        return role === Role.COMPANY;
    }

    return true;
}

/**
 * Returns null to stay on the current page, or a path to navigate to after a role switch.
 */
export function getRoleSwitchNavigationTarget(pathname: string, role: string): string | null {
    if (canAccessPathWithRole(pathname, role)) {
        return null;
    }

    return ROUTES.ACCOUNT_PROFILE;
}
